<template>
    <modal class="account-modal user-pair-modal" @close="actionHideModal">
        <template slot="header">
            <div class="modal-title-container">
                <p>{{$t('Pair account with e-mail')}}</p>
                <div class="icon-container">
                    <md-icon @click.native="actionHideModal">{{$t('clear')}}</md-icon>
                </div>
            </div>
            <h4 class="modal-title" v-text="userEmail"></h4>
        </template>
        <template slot="body">
            <md-table class="table-striped">
                <template v-if="showUsers">
                    <md-table-row v-for="(user, key) in users" :key="key">
                        <md-table-cell class="modal-radio">
                            <md-radio v-model="selectedUserId" :value="user.id"></md-radio>
                        </md-table-cell>
                        <md-table-cell class="modal-username"
                                       v-text="getDisplayUsername(user)"></md-table-cell>
                    </md-table-row>
                </template>
                <md-table-row v-else>
                    <md-table-cell colspan="2">{{$t('No accounts to pair')}}</md-table-cell>
                </md-table-row>
            </md-table>
        </template>
        <template slot="footer">
            <md-button class="md-simple modal-btn" @click.native="actionHideModal">{{$t('Cancel')}}</md-button>
            <md-button class="md-primary modal-btn" :disabled="!showUsers" @click.native="actionPair">{{$t('Pair account')}}
            </md-button>
        </template>
    </modal>
</template>

<script>
    import Modal from "../components/Modal";

    export default {
        name: "UserPairModal",
        components: {Modal},
        props: {
            appSlug: {
                type: String,
                required: true,
            },
            user: {
                type: Object,
                required: true,
            }
        },
        computed: {
            userId() {
                return this.user.id ?? null;
            },
            userEmail() {
                return this.user.email ?? '-';
            },
            parent() {
                return this.$parent.$parent.$parent.$parent.$parent;
            },
            showUsers() {
                return this.users.length > 0;
            }
        },
        data() {
            return {
                users: [],
                selectedUserId: null,
            }
        },
        methods: {
            actionHideModal() {
                this.parent.actionHideModal(this.appSlug);
            },
            initUsers() {
                this.$api.unpairedAccounts({
                    params: {
                        app: this.appSlug,
                    }
                }).then(({data}) => {
                    this.users = data;
                    this.selectedUserId = this.users[0] !== undefined ? this.users[0].id : null;
                });
            },
            actionPair() {
                this.$api.pairAccountAdmin({
                    data: {
                        app: this.appSlug,
                        authId: this.userId,
                        oldId: this.selectedUserId,
                    }
                }).then(() => {
                    let access = this.parent.itemData.accesses.find(access => {
                        return access.appSlug === this.appSlug;
                    });

                    access.hasAccess = true;
                }).finally(() => {
                    this.actionHideModal();
                });
            },
            getDisplayUsername(user) {
                return user.username + ' (' + user.first_name + ' ' + user.last_name + ')'
            }
        },
        mounted() {
            this.initUsers();
        }
    }
</script>

<style lang="scss">
    .user-pair-modal {
        p {
            margin: 0 !important;
        }
    }

    .modal-radio {
        width: 72px;
    }

    .modal-username {
        text-align: left !important;
    }

    .modal-btn {
        padding: 0 !important;
        line-height: normal !important;
        display: inline-block !important;
        width: auto !important;
        height: auto !important;
    }
</style>